export default __webpack_public_path__ + "c2.png";